import React, { ReactElement, useEffect } from 'react';
import Layout from '../Layout';
import Home from '../../module/Home';

export default (): ReactElement => {
  useEffect(() => {
    window.parent.postMessage({
      type: 'iframe-to-parent-set-meta',
      title: 'Slov-Lex',
      description: 'Oficiálny právny a informačný portál Slovenskej republiky. '
          + 'Prístup k aktuálnym zákonom, legislatívnym procesom, súdnym rozhodnutiam a i.',
    }, '*');
  }, []);

  return (
    <Layout>
      <Home />
    </Layout>
  );
};
